import { MENU_HEADERS, PAGE } from "components/common/CONSTANTS";

export const menuSortOrder = [
  MENU_HEADERS.THIRD_PARTY_ORDERS,
  MENU_HEADERS.EMERGENCY_ORDERS,
  MENU_HEADERS.MANUAL_ORDERS,
  MENU_HEADERS.ADMIN,
];

export const menuItems = {
    downloadcustomerdemands: {
      name: PAGE.DOWNLOAD_CUSTOMER_DEMANDS.label,
      url: PAGE.DOWNLOAD_CUSTOMER_DEMANDS.url,
      breadcrumbName: PAGE.DOWNLOAD_CUSTOMER_DEMANDS.label,
      header: MENU_HEADERS.THIRD_PARTY_ORDERS,
    },
    uploadcustomerdemands: {
      name: PAGE.UPLOAD_CUSTOMER_DEMANDS.label,
      url: PAGE.UPLOAD_CUSTOMER_DEMANDS.url,
      breadcrumbName: PAGE.UPLOAD_CUSTOMER_DEMANDS.label,
      header: MENU_HEADERS.THIRD_PARTY_ORDERS,
    },
    downloademergencyorders: {
      name: PAGE.DOWNLOAD_EMERGENCY_ORDERS.label,
      url: PAGE.DOWNLOAD_EMERGENCY_ORDERS.url,
      breadcrumbName: PAGE.DOWNLOAD_EMERGENCY_ORDERS.label,
      header: MENU_HEADERS.EMERGENCY_ORDERS,
    },
    uploademergencyorders: {
      name: PAGE.UPLOAD_EMERGENCY_ORDERS.label,
      url: PAGE.UPLOAD_EMERGENCY_ORDERS.url,
      breadcrumbName: PAGE.UPLOAD_EMERGENCY_ORDERS.label,
      header: MENU_HEADERS.EMERGENCY_ORDERS,
    },
    createmanualorders: {
      name: PAGE.CREATE_MANUAL_ORDERS.label,
      url: PAGE.CREATE_MANUAL_ORDERS.url,
      breadcrumbName: PAGE.CREATE_MANUAL_ORDERS.label,
      header: MENU_HEADERS.MANUAL_ORDERS,
      sortMenu: 1
    },
    uploadmanualorders: {
      name: PAGE.UPLOAD_MANUAL_ORDERS.label,
      url: PAGE.UPLOAD_MANUAL_ORDERS.url,
      breadcrumbName: PAGE.UPLOAD_MANUAL_ORDERS.label,
      header: MENU_HEADERS.MANUAL_ORDERS,
      sortMenu: 1
    },
    amendmanualorders: {
      name: PAGE.AMEND_MANUAL_ORDERS.label,
      url: PAGE.AMEND_MANUAL_ORDERS.url,
      breadcrumbName: PAGE.AMEND_MANUAL_ORDERS.label,
      header: MENU_HEADERS.MANUAL_ORDERS,
      sortMenu: 3
    },
    approvemanualorders: {
      name: PAGE.APPROVE_MANUAL_ORDERS.label,
      url: PAGE.APPROVE_MANUAL_ORDERS.url,
      breadcrumbName: PAGE.APPROVE_MANUAL_ORDERS.label,
      header: MENU_HEADERS.MANUAL_ORDERS,
      sortMenu: 2
    },
    viewmanualorders: {
      name: PAGE.VIEW_MANUAL_ORDERS.label,
      url: PAGE.VIEW_MANUAL_ORDERS.url,
      breadcrumbName: PAGE.VIEW_MANUAL_ORDERS.label,
      header: MENU_HEADERS.MANUAL_ORDERS,
      sortMenu: 4
    },
    viewmanualordersauditdetails: {
      name: PAGE.VIEW_MANUAL_ORDERS_AUDIT_DETAILS.label,
      url: PAGE.VIEW_MANUAL_ORDERS_AUDIT_DETAILS.url,
      breadcrumbName: PAGE.VIEW_MANUAL_ORDERS_AUDIT_DETAILS.label,
      header: MENU_HEADERS.MANUAL_ORDERS,
      sortMenu: 5
    },
    createmanualordersstores: {
      name: PAGE.SITE_CANTEEN.label,
      url: PAGE.SITE_CANTEEN.url,
      breadcrumbName: PAGE.SITE_CANTEEN.label,
      header: MENU_HEADERS.MANUAL_ORDERS,
      sortMenu: 6
    },
    manageuser: {
      name: PAGE.MANAGE_USER.label,
      url: PAGE.MANAGE_USER.url,
      breadcrumbName: PAGE.MANAGE_USER.label,
      header: MENU_HEADERS.ADMIN,
    },
    configuregoldenstores: {
      name: PAGE.GOLDEN_STORE.label,
      url: PAGE.GOLDEN_STORE.url,
      breadcrumbName: PAGE.GOLDEN_STORE.label,
      header: MENU_HEADERS.ADMIN,
    },
    donotorderlist: {
      name: PAGE.DO_NOT_ORDER_LIST.label,
      url: PAGE.DO_NOT_ORDER_LIST.url,
      breadcrumbName: PAGE.DO_NOT_ORDER_LIST.label,
      header: MENU_HEADERS.ADMIN,
    },
    supplierdestinationconfiguration: {
      name: PAGE.SUPPLIER_DESTINATION_CONFIGURATION.label,
      url: PAGE.SUPPLIER_DESTINATION_CONFIGURATION.url,
      breadcrumbName: PAGE.SUPPLIER_DESTINATION_CONFIGURATION.label,
      header: MENU_HEADERS.ADMIN,
    },
    itemexclusionconfiguration: {
      name: PAGE.ITEM_EXCLUSION_CONFIGURATION.label,
      url: PAGE.ITEM_EXCLUSION_CONFIGURATION.url,
      breadcrumbName: PAGE.ITEM_EXCLUSION_CONFIGURATION.label,
      header: MENU_HEADERS.ADMIN,
    },
    uploadmanualorderpo: {
      name: PAGE.UPLOAD_CREATE_MANUAL_ORDER_PO.label,
      url: PAGE.UPLOAD_CREATE_MANUAL_ORDER_PO.url,
      breadcrumbName: PAGE.CREATE_MANUAL_ORDER_PO.label,
      header: MENU_HEADERS.MANUAL_ORDER_PO,
      sortMenu: 1
    },
    posummary: {
      name: PAGE.PO_SUMMARY.label,
      url: PAGE.PO_SUMMARY.url,
      breadcrumbName: PAGE.PO_SUMMARY.label,
      header: MENU_HEADERS.MANUAL_ORDER_PO,
      sortMenu: 2
    },
  },
  customerType = [
    {
      CustomerId: "wholesale",
      CustomerName: "All",
      CustomerType: "wholesale",
    },
    {
      CustomerId: "Online",
      CustomerName: "Online",
      CustomerType: "online",
    },
    {
      CustomerId: "AMZ",
      CustomerName: "Amazon",
      CustomerType: "wholesale",
    },
    {
      CustomerId: "DHL",
      CustomerName: "DHL",
      CustomerType: "wholesale",
    },
  ],
  downloadType = [
    {
      DownloadTypeId: "all",
      DownloadTypeName: "All",
    },
    {
      DownloadTypeId: "fresh",
      DownloadTypeName: "Fresh",
    },
    {
      DownloadTypeId: "frozen",
      DownloadTypeName: "Frozen",
    },
    {
      DownloadTypeId: "ambient",
      DownloadTypeName: "Ambient",
    },
    {
      DownloadTypeId: "tobacco",
      DownloadTypeName: "Tobacco",
    },
  ],
  amendReasonData = [
    {
      Id: "Original order too high",
      Reason: "Original order too high",
      reasonType: "online",
    },
    {
      Id: "Original order too low",
      Reason: "Original order too low",
      reasonType: "online",
    },
    {
      Id: "Order not proceed into M systems",
      Reason: "Order not proceed into M systems",
      reasonType: "online",
    },
    {
      Id: "Incorrect quantity received on order",
      Reason: "Incorrect quantity received on order",
      reasonType: "wholesale",
    },
    {
      Id: "Residual stock of item",
      Reason: "Residual stock of item",
      reasonType: "wholesale",
    },
    {
      Id: "Item stocked in DHL location",
      Reason: "Item stocked in DHL location",
      reasonType: "wholesale",
    },
    {
      Id: "Amazon ad-hoc order",
      Reason: "Amazon ad-hoc order",
      reasonType: "wholesale",
    },
    {
      Id: "Contingency - orders unavailable",
      Reason: "Contingency - orders unavailable",
      reasonType: "wholesale",
    },
    {
      Id: "Ad-hoc customer request",
      Reason: "Ad-hoc customer request",
      reasonType: "wholesale",
    },
    {
      Id: "Ad-hoc Event/Seasonal/Promo",
      Reason: "Ad-hoc Event/Seasonal/Promo",
      reasonType: "wholesale",
    },
  ]

export const csvDataToDownload = [
  {
    pin: "110742128",
    min: "110742047",
    fromLocation: "807",
    toLocation: "466",
    reasonCode: "16",
    quantity: "501",
  },
  {
    pin: "100506657",
    min: "111276229",
    fromLocation: "966",
    toLocation: "217",
    reasonCode: "12",
    quantity: "100",
  },
];
export const csvErrorDataToDownload = [
  {
    orderDate: "20241107",
    pin: "E100003100",
    min: "100001707",
    fromLocation: "870",
    toLocation: "301",
    quantity: "146",
  },
  {
    orderDate: "20241107",
    pin: "112437442",
    min: "112437434",
    fromLocation: "E760",
    toLocation: "304",
    quantity: "25",
  },
  {
    orderDate: "E20241108",
    pin: "111707720",
    min: "111707711",
    fromLocation: "924",
    toLocation: "285",
    quantity: "E2001",
  },
  {
    orderDate: "20241108",
    pin: "109144122",
    min: "E109144092",
    fromLocation: "712",
    toLocation: "6619",
    quantity: "11",
  },
  {
    orderDate: "ER20241108",
    pin: "ER100073100",
    min: "ER100081707",
    fromLocation: "ER870",
    toLocation: "ER301",
    quantity: "ER146",
  },
];

export const csvTemplate = [
  {
    pin: "",
    min: "",
    fromLocation: "",
    toLocation: "",
    reasonCode: "",
    quantity: "",
  },
];
export const editedJson = [
  {
    pin: "",
    min: "",
    fromLocation: "",
    toLocation: "",
    reasonCode: "",
    quantity: "",
  },
];
